import { createPaginatedRequestAtom } from '../../../../../shared/utils/request-atom';
import { OrgOwner, OrgOwnersPaginationParams } from './typings';

export const orgOwnersAtom = createPaginatedRequestAtom<OrgOwner, OrgOwnersPaginationParams>({
  loading: false,
});
